import { FC, ButtonHTMLAttributes, Fragment } from "react";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "@/shared/utils/classnames";

export const buttonSizes: any = {
  xs: "px-2 py-1 text-xs h-6",
  sm: "px-2 py-1 text-sm h-8",
  md: "px-2.5 py-1.5 text-base h-10",
  lg: "px-3 py-2 text-lg h-12",
  xl: "px-3.5 py-2.5 text-xl h-16",
};

export type ButtonLogin = ButtonHTMLAttributes<HTMLButtonElement> & {
  primary?: boolean;
  text?: string;
  size?: keyof typeof buttonSizes;
  iconLeft?: IconDefinition;
  iconRight?: IconDefinition;
  isLoading?: boolean;
  icon?: IconDefinition;
  tooltip?: string;
};

export const ButtonLogin: FC<ButtonLogin> = ({
  primary,
  size = "sm",
  iconLeft,
  iconRight,
  text,
  children,
  isLoading,
  className,
  icon,
  tooltip,
  ...props
}) => {
  const sizeClassName = buttonSizes[size];

  return (
    <Fragment>
      <button
        {...props}
        type="button"
        className={classNames(
          `flex items-center rounded-md font-semibold gap-2 cursor-pointer`,
          primary
            ? "ring-customPurple/80 bg-customPurple hover:bg-customPurple/80 text-white"
            : "ring-gray-300 hover:bg-gray-50 text-gray-900 ",
          icon ? "aspect-square" : "ring-1 ring-inset shadow-sm",
          sizeClassName,
          className,
          tooltip && "relative"
        )}
      >
        {text}

        {isLoading && (
          <div
            className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
            role="status"
          ></div>
        )}
      </button>
    </Fragment>
  );
};
